export default [
  {
    title: "Home",
    route: "home",
    icon: "HomeIcon",
  },
  {
    title: "Dashboard",
    route: "dashboard",
    icon: "GridIcon",
    resource: "dashboard",
    action: "read",
    allowedCountries: ["LY"],
  },
  {
    title: "Supply & Demand",
    route: "supply-and-demand",
    icon: "ActivityIcon",
    resource: "supply-and-demand",
    action: "read",
  },
  {
    title: "Subscriptions",
    icon: "GiftIcon",
    children: [
      {
        title: "Subscription Plans",
        route: "subscription-plans",
        icon: "GiftIcon",
        resource: "subscriptions",
        action: "read",
      },
      {
        title: "Subscribed Users",
        route: "subscribed-users",
        icon: "GiftIcon",
        resource: "subscriptions",
        action: "read",
      },
      {
        title: "Subscription Benefits",
        route: "subscription-benefits",
        icon: "GiftIcon",
        resource: "subscriptions",
        action: "read",
      },
    ],
  },
  {
    title: "Marketing",
    icon: "ActivityIcon",
    children: [
      {
        title: "Splash Screen",
        icon: "ActivityIcon",
        route: "splash-screen-list",
        resource: "splash-screen",
        action: "read",
      },
      {
        icon: "BellIcon",
        route: "notifications",
        title: "Notifications",
        resource: "notifications",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Promo Codes",
        route: "promo-codes",
        icon: "KeyIcon",
        resource: "promo-codes",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Groups",
        route: "groups",
        icon: "UsersIcon",
        resource: "groups",
        action: "read",
      },
      {
        title: "Rewards",
        icon: "GiftIcon",
        route: "rewards",
        resource: "rewards",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Challenges",
        icon: "GiftIcon",
        route: "challenges",
        resource: "rewards",
        action: "read",
      },
      {
        title: "Announcements",
        icon: "BellIcon",
        route: "annoucements-list",
        resource: "announcement",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Advertisements",
        icon: "ActivityIcon",
        route: "advertisements-list",
        resource: "advertisement",
        action: "read",
      },
      {
        title: "Extra Payment Discount Config",
        icon: "DollarSignIcon",
        route: "extra-payment-discount",
      },
    ],
  },
  {
    title: "Logs",
    route: "logs",
    icon: "GridIcon",
    resource: "logs",
    action: "read",
  },
  {
    title: "Trips",
    icon: "TruckIcon",
    children: [
      {
        title: "Trips List",
        route: "trips",
        icon: "TruckIcon",
        resource: "trips",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Bookings",
        route: "bookings-list",
        icon: "TruckIcon",
        resource: "schedules",
        action: "read",
      },
      {
        title: "Create Trip",
        route: "trips-new",
        icon: "TruckIcon",
        resource: "create-trip",
        action: "write",
        allowedCountries: ["LY"],
      },
      {
        title: "Trip Configurations",
        route: "trip-config",
        icon: "GridIcon",
        resource: "trips-config",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Fraud Trips",
        route: "fraud-trips",
        icon: "GridIcon",
        resource: "fraud-trips",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Heatmap Polygons",
        route: "heatmap-polygons",
        icon: "MapIcon",
        resource: "heatmap",
        action: "read",
      },
    ],
  },
  {
    title: "Drivers",
    icon: "UsersIcon",
    children: [
      {
        title: "Verified",
        route: "drivers-list",
        icon: "UsersIcon",
        resource: "verified-drivers",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Teams",
        icon: "UsersIcon",
        children: [
          {
            title: "Teams List",
            route: "teams-list",
            resource: "teams",
            action: "read",
          },
          {
            title: "Levels",
            route: "levels-list",
            resource: "teams",
            action: "read",
          },
          {
            title: "Reasons",
            route: "teams-reasons-tabs",
            resource: "teams",
            action: "read",
          },
          // {
          //   title: 'Leave Reasons',
          //   route: 'leave-reasons-list',
          //   resource: 'teams',
          //   action: 'read',
          // },
          // {
          //   title: 'Delete Reasons',
          //   route: 'delete-reasons-list',
          //   resource: 'teams',
          //   action: 'read',
          // },
        ],
      },
      {
        title: "Location",
        route: "drivers-location",
        icon: "MapIcon",
        resource: "drivers-location",
        action: "read",
      },
      {
        title: "Blocked",
        route: "blocked-drivers-list",
        icon: "UsersIcon",
        resource: "blocked-drivers",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Unverified",
        route: "unverified-drivers-list",
        icon: "UsersIcon",
        resource: "unverified-drivers",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Get OTP",
        route: "get-driver-otp",
        icon: "CheckIcon",
        resource: "get-otp-drivers",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Registration Reports",
        route: "drivers-registration-reports",
        icon: "ActivityIcon",
        resource: "drivers-registration-reports",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Learning Center",
        route: "drivers-learning-center",
        icon: "ActivityIcon",
        resource: "learning-center-management",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Shifts",
        icon: "ClockIcon",
        route: "drivers-shifts",
        resource: "driver-inactivations",
        action: "read",
      },
      {
        title: "Violations",
        icon: "XIcon",
        children: [
          {
            title: "Configuration",
            route: "violations",
            icon: "ActivityIcon",
            resource: "violations",
            action: "read",
          },
          {
            title: "Drivers Violations",
            route: "drivers-violations-list",
            icon: "XIcon",
            resource: "drivers-violations",
            action: "read",
          },
        ],
      },
      {
        title: "Liveness Check",
        route: "liveness-check-list",
        icon: "CheckCircleIcon",
      },
      {
        title: "Learning Center Quiz",
        icon: "HelpCircleIcon",
        route: "learning-center-quiz",
        resource: "drivers-quiz",
        action: "read",
      },
    ],
  },
  {
    title: "Users",
    icon: "UsersIcon",
    children: [
      {
        title: "Users List",
        route: "users-list",
        icon: "UsersIcon",
        resource: "users",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Get OTP",
        route: "get-user-otp",
        icon: "CheckIcon",
        resource: "get-otp-users",
        action: "read",
      },
      {
        title: "Fines",
        route: "list-user-fines",
        icon: "AlertCircleIcon",
        resource: "fine-events",
        action: "read",
      },
      {
        title: "ETA Logs",
        route: "eta-logs",
        icon: "ClockIcon",
        resource: "users",
        action: "read",
      },
    ],
  },

  {
    title: "Dispatch Configurations",
    route: "dispatch-configurations",
    icon: "SettingsIcon",
    resource: "dispatch-configurations",
    action: "read",
  },
  {
    title: "Zones/Services",
    route: "zones-services",
    icon: "SettingsIcon",
    resource: "zones/services",
    action: "read",
    allowedCountries: ["LY"],
  },
  {
    title: "Access",
    icon: "LockIcon",
    children: [
      {
        title: "Admins",
        icon: "UsersIcon",
        route: "users-admins",
        resource: "roles",
        action: "read",
      },
      {
        title: "Roles",
        icon: "UserCheckIcon",
        route: "users-roles",
        resource: "roles",
        action: "read",
      },
    ],
  },
  {
    title: "Billing",
    icon: "DollarSignIcon",
    children: [
      {
        title: "Competitors ETA",
        route: "comp-eta",
        icon: "DollarSignIcon",
      },
      {
        title: "Configured Competitors ETA",
        route: "configured-comp-eta",
        icon: "DollarSignIcon",
      },
      {
        title: "Pricing Override",
        icon: "GridIcon",
        route: "pricing-overrides",
        resource: "pricing-override",
        action: "read",
      },
      {
        title: "Transaction Types",
        icon: "SlidersIcon",
        route: "transaction-types",
        resource: "transaction-types",
        action: "read",
      },
      {
        title: "Bulks",
        icon: "DollarSignIcon",
        children: [
          {
            title: "List",
            route: "transaction-bulks-list",
            icon: "DollarSignIcon",
            resource: "transaction-bulks",
            action: "read",
          },
          {
            title: "Add/Deduct",
            route: "create-transaction-bulks",
            icon: "DollarSignIcon",
            resource: "transaction-bulks",
            action: "write",
          },
        ],
      },
      {
        title: "Pricing Templates",
        icon: "GridIcon",
        route: "pricing-templates",
        resource: "templates",
        action: "read",
      },
      {
        title: "Versions History",
        icon: "GridIcon",
        route: "versions-history",
        resource: "versions",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Pricing Config",
        icon: "GridIcon",
        route: "versions-prepare-pricing",
        resource: "versions",
        action: "read",
        allowedCountries: ["LY"],
      },
      {
        title: "Vouchers",
        icon: "AnchorIcon",
        children: [
          {
            title: "Vendors",
            icon: "GridIcon",
            route: "vendors",
            resource: "vendors",
            action: "read",
          },
          {
            title: "Batch Jobs",
            icon: "CreditCardIcon",
            route: "batch",
            resource: "voucher-cards",
            action: "read",
          },
          {
            title: "Cards",
            icon: "CreditCardIcon",
            route: "cards",
            resource: "voucher-cards",
            action: "read",
          },
        ],
      },
      {
        title: "Payouts",
        icon: "DollarSignIcon",
        children: [
          {
            title: "Create Payout",
            icon: "DollarSignIcon",
            route: "new",
            resource: "payout-actions",
            action: "write",
          },
          {
            title: "Pending",
            icon: "DollarSignIcon",
            route: "pending",
            resource: "payout-actions",
            action: "read",
          },
          {
            title: "Approved",
            icon: "DollarSignIcon",
            route: "approved",
            resource: "payout-actions-pay",
            action: "read",
          },
          {
            title: "Rejected",
            icon: "DollarSignIcon",
            route: "rejected",
            resource: "payout-actions",
            action: "read",
          },
          {
            title: "Paid",
            icon: "DollarSignIcon",
            route: "paid",
            resource: "payout-actions-pay",
            action: "read",
          },
        ],
      },
      {
        title: "Zones Management",
        icon: "CreditCardIcon",
        route: "zones-management-sub-zones",
        resource: "pricing-overrides",
        action: "read",
      },
    ],
  },
  {
    title: "Businesses",
    icon: "ActivityIcon",
    children: [
      {
        route: "businesses-types",
        title: "Business Types",
        icon: "ActivityIcon",
        resource: "businesses-types",
        action: "read",
      },
      {
        route: "food-orders-list",
        title: "Orders",
        icon: "ActivityIcon",
        resource: "businesses-orders",
        action: "read",
      },
      {
        route: "businesses-list",
        title: "Businesses List",
        icon: "ActivityIcon",
        resource: "businesses-list",
        action: "read",
      },
      {
        route: "businesses-pending-approvals",
        title: "Pending Approvals",
        icon: "ActivityIcon",
        resource: "businesses-pending-approvals",
        action: "read",
      },
      {
        route: "businesses-tags",
        title: "Tags",
        icon: "ActivityIcon",
        resource: "businesses-tags",
        action: "read",
      },
      {
        route: "businesses-document-types",
        title: "Document Types",
        icon: "ActivityIcon",
        resource: "businesses-document-types",
        action: "read",
      },
      {
        route: "businesses-heros",
        title: "Heros",
        icon: "ActivityIcon",
        resource: "businesses-heros",
        action: "read",
      },
    ],
  },
  {
    title: "Jobs",
    route: "jobs",
    icon: "SettingsIcon",
    resource: "jobs",
    action: "read",
  },
];
